import { render, staticRenderFns } from "./ListadoProgramasPaginados.vue?vue&type=template&id=f7560d66"
import script from "./ListadoProgramasPaginados.vue?vue&type=script&lang=js"
export * from "./ListadoProgramasPaginados.vue?vue&type=script&lang=js"
import style0 from "./ListadoProgramasPaginados.vue?vue&type=style&index=0&id=f7560d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports